import { z } from "zod/v4";

import { GoogleGaAudienceSchema } from "../../../../../schemas/google";

export const PutGaExpIntegrationRequestBodySchema = z.object({
  experimentId: z.uuid(),
  enabled: z.boolean(),
  audiences: GoogleGaAudienceSchema.array(),
});

export type PutGaExpIntegrationRequestBodySchemaType = z.infer<
  typeof PutGaExpIntegrationRequestBodySchema
>;

export const PutGaExpIntegrationResponseBodySchema = z.object({
  integration: PutGaExpIntegrationRequestBodySchema,
});
export type PutGaExpIntegrationResponseBodyType = z.infer<
  typeof PutGaExpIntegrationResponseBodySchema
>;
